import React from 'react';
import { UI_COLORS, colorHelpers } from '../../utils/colors';
import { EXTERNAL_LINKS } from '../../utils/constants';
import { useTranslation } from 'react-i18next';

/**
 * DeveloperCredit - Shows developer attribution with link
 * 
 * Props:
 * - className: additional CSS classes for positioning/styling
 * - style: inline styles for custom positioning
 * - variant: 'sidebar' | 'footer' - affects text size and styling
 */
const DeveloperCredit = ({ 
  className = '', 
  style = {}, 
  variant = 'footer'
}) => {
  const { t } = useTranslation();
  const textSize = variant === 'sidebar' ? 'text-xs' : 'text-sm';
  const padding = variant === 'sidebar' ? 'py-2 px-3' : 'py-3 px-4';

  return (
    <div 
      className={`${padding} text-center ${className}`}
      style={{
        backgroundColor: colorHelpers.withOpacity(UI_COLORS.BRAND.PRIMARY, 0.1),
        borderTop: variant === 'footer' ? `1px solid ${UI_COLORS.BRAND.PRIMARY}` : 'none',
        ...style
      }}
    >
      <p className={`${textSize} font-semibold`}>
        <span style={{ color: UI_COLORS.TEXT.PRIMARY }}>
          {t('common.developerCredit.prefix')}{' '}
        </span>
        <a
          href={EXTERNAL_LINKS.DEVELOPER_WEBSITE}
          target="_blank"
          rel="noopener noreferrer"
          className={`${textSize} font-bold transition-colors duration-200 hover:underline`}
          style={{ 
            color: UI_COLORS.TEXT.BLACK,
            textDecoration: 'none'
          }}
          onMouseEnter={(e) => {
            e.target.style.color = UI_COLORS.TEXT.BLACK;
          }}
          onMouseLeave={(e) => {
            e.target.style.color = UI_COLORS.TEXT.BLACK;
          }}
        >
          {t('common.developerCredit.linkText')}
        </a>
      </p>
    </div>
  );
};

export default DeveloperCredit;